export default function R_Comments() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Comments Component</h1>
      <p>This is the R_Comments tutorial section.</p>
    </div>
  );
}
